import React, { useContext, useState } from 'react';
import { HashRouter, Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import { userContext } from '../../../contextProvider/Authentication';
import { getBase64 } from '../../../Functions/apis';
import axiosInstance from '../../../services/AxiosInstance';
import userImg from '../../../images/defaultuserimage.jpg';
import FileUpload from '../../Element/FileUpload';
import Employer from './Users/Employers';
import Candidate from './Users/Candidates';
import Jobs from './Jobs';
import ConJobsandCandis from './CandidateRecommends/ConJobsandCandis';
import Transactions from './Transactions';
import CandidateApplications from './CandidateApplications';
import { decrypt } from '../../../Functions/authentication';
import ConSuggestedCandidates from './CandidateRecommends/ConSuggestedCandidates';
import SupportCareerLevel from './SupportData/SupportCareerLevel';
import SupportCategories from './SupportData/SupportCategories';
import SupportCompanyCategories from './SupportData/SupportCompanyCategories';
import SupportCompanyTypes from './SupportData/SupportCompanyTypes';
import SupportCourse from './SupportData/SupportCourse';
import SupportIndustries from './SupportData/SupportIndustries';
import SupportJobTypes from './SupportData/SupportJobTypes';
import SupportQualification from './SupportData/SupportQualification';
import SupportSpecialization from './SupportData/SupportSpecialization';
import SupportQualificationLevel from './SupportData/SupportQualificationLevel';
import SupportJobTitle from './SupportData/SupportJobTitle';
import SupportLanguage from './SupportData/SupportLanguage';
import SupportCity from './SupportData/SupportCity';
import SupportState from './SupportData/SupportState';
import SupportCountry from './SupportData/SupportCountry';
import EmployerProfile from './EmployerProfile';
import CandidateProfile from './CandidateProfile';
import Notifications from './Notifications';


const Layout = () => {

    const { pathname } = useLocation();
    const fullview = pathname.split('/').includes('candidate-profile');
    const { user, authenticated } = useContext(userContext);

    const [pimg, setPimg] = useState(() => {
        if (authenticated) {
            return localStorage.getItem('pimg');
        } else return null;
    });

    const handleImageChange = e => {
        let file = e.target.files[0];
        if (file.size < 1024000) {
            getBase64(file)
                .then(result => {
                    axiosInstance(`/user/${user?.id}/`, { method: "PATCH", data: { "pimg": result } });
                    localStorage.setItem("pimg", result);
                    setPimg(result);
                })
        }
        else swal("", "The Image size should be less than 1mb", "error", { button: "Ok!", })
    }

    const menus = [
        { link: "/joc/employers", label: "Employer", icon: "fa fa-address-card", active: pathname },
        { link: "/joc/candidates", label: "Candidate", icon: "fa fa-address-book", active: pathname },
        { link: "/joc/all-jobs", label: "Jobs", icon: "fa fa-briefcase", active: pathname },
        { link: "/joc/filter-candidates", label: "Filter Candidates", icon: "fa fa-briefcase", active: pathname },
        { link: "/joc/joc-transactions", label: "Transactions", icon: "fa fa-random", active: pathname },
        { link: "/joc/candidate-application", label: "Candidate Application", icon: "fa fa-users", active: pathname },
    ]

    function AuthenticatedRoute({ component: Component, ...rest }) {
        let role = localStorage.getItem('user') && decrypt(localStorage.getItem('user'), 'lsuser');
        return (
            <Route
                {...rest}
                render={(props) => {
                    return authenticated ? (
                        rest?.role?.includes(role?.role) ?
                            <Component {...props} {...rest} />
                            :
                            <Redirect to="/not-authorized" />
                    ) : (
                        <Redirect to="/login" />
                    );
                }}
            />
        )
    }

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white browse-job p-t50 p-b20">
                    <div className="ml-5 mr-5">
                        <div className="row">
                            {/* SideBar */}
                            {
                                !fullview &&
                                <div className="col-xl-3 col-lg-4 m-b30">
                                    <div className="sticky-top">
                                        <div className="candidate-info">
                                            <div className="candidate-detail text-center">
                                                <div className="canditate-des">
                                                    <Link to={'#'}>
                                                        <img alt="" src={pimg ? pimg : userImg} />
                                                    </Link>
                                                    <div className="upload-link" title="update" data-toggle="tooltip" data-placement="right">
                                                        <FileUpload
                                                            url={`/user/${user?.id}/`}
                                                            className="update-flie"
                                                            handleChange={handleImageChange}
                                                        />
                                                        <i className="fa fa-camera"></i>
                                                    </div>
                                                </div>
                                                <div className="candidate-title">
                                                    <div className="">
                                                        <h4 className="m-b5"><Link to={"#"}>{user?.first_name}</Link></h4>
                                                        {/* <p className="m-b0"><Link to={"#"}>Web developer</Link></p> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <ul>
                                                {
                                                    menus.map(res =>
                                                        <li key={res.link}>
                                                            <Link to={res.link} className={pathname === res.link ? 'active' : ''}>
                                                                <i className={res.icon} aria-hidden="true"></i>
                                                                <span>{res.label}</span>
                                                            </Link>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* ------ SideBar ------- */}
                            {/* Components */}
                            <div className={`${fullview ? "col-xl-12" : "col-xl-9"} col-lg-8 m-b30`}>
                                {/* {children} */}
                                <HashRouter>
                                    <Switch>
                                        <AuthenticatedRoute
                                            path="/joc/employers"
                                            exact={true}
                                            component={Employer}
                                            name='Employer'
                                            role={[1]}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/candidates"
                                            exact={true}
                                            role={[1]}
                                            name='Candidate'
                                            component={Candidate}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/all-jobs"
                                            exact={true}
                                            role={[1]}
                                            name='Jobs'
                                            component={Jobs}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/filter-candidates"
                                            exact={true}
                                            role={[1]}
                                            name='ConJobsandCandis'
                                            component={ConJobsandCandis}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/joc-transactions/:debug?"
                                            exact={true}
                                            role={[1]}
                                            name='JocTransactions'
                                            component={Transactions}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/candidate-application"
                                            exact={true}
                                            role={[1]}
                                            name='CandidateApplications'
                                            component={CandidateApplications}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/joc-suggest-candidates/:id/:vac?"
                                            exact={true}
                                            role={[1]}
                                            name='ConSuggestedCandidates'
                                            component={ConSuggestedCandidates}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/employer-profile/:id?"
                                            exact={true}
                                            role={[1]}
                                            name='EmployerProfile'
                                            component={EmployerProfile}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/candidate-profile/:id?"
                                            exact={true}
                                            role={[1]}
                                            name='CandidateProfile'
                                            component={CandidateProfile}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/notifications"
                                            exact={true}
                                            role={[1]}
                                            name='JocNotifications'
                                            component={Notifications}
                                        />

                                        {/* Support Datas start */}
                                        <AuthenticatedRoute
                                            path="/joc/qualification-level"
                                            exact={true}
                                            role={[1]}
                                            name='SupportQualificationLevel'
                                            component={SupportQualificationLevel}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/qualifications"
                                            exact={true}
                                            role={[1]}
                                            name='SupportQualification'
                                            component={SupportQualification}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/courses"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCourse'
                                            component={SupportCourse}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/specializations"
                                            exact={true}
                                            role={[1]}
                                            name='SupportSpecialization'
                                            component={SupportSpecialization}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/job-categories"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCategories'
                                            component={SupportCategories}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/job-types"
                                            exact={true}
                                            role={[1]}
                                            name='SupportJobTypes'
                                            component={SupportJobTypes}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/job-titles"
                                            exact={true}
                                            role={[1]}
                                            name='SupportJobTitle'
                                            component={SupportJobTitle}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/industries"
                                            exact={true}
                                            role={[1]}
                                            name='SupportIndustries'
                                            component={SupportIndustries}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/company-types"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCompanyTypes'
                                            component={SupportCompanyTypes}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/career-levels"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCareerLevel'
                                            component={SupportCareerLevel}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/company-categories"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCompanyCategories'
                                            component={SupportCompanyCategories}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/languages"
                                            exact={true}
                                            role={[1]}
                                            name='SupportLanguage'
                                            component={SupportLanguage}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/cities"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCity'
                                            component={SupportCity}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/states"
                                            exact={true}
                                            role={[1]}
                                            name='SupportState'
                                            component={SupportState}
                                        />
                                        <AuthenticatedRoute
                                            path="/joc/countries"
                                            exact={true}
                                            role={[1]}
                                            name='SupportCountry'
                                            component={SupportCountry}
                                        />
                                        {/* Support Datas end */}
                                    </Switch>
                                </HashRouter>
                            </div>
                            {/* ----- Components ----- */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;